import { render, staticRenderFns } from "./Logopedists.vue?vue&type=template&id=3d8ec4f6"
import script from "./Logopedists.vue?vue&type=script&lang=js"
export * from "./Logopedists.vue?vue&type=script&lang=js"
import style0 from "./Logopedists.vue?vue&type=style&index=0&id=3d8ec4f6&prod&module=true&lang=scss"
import style1 from "./Logopedists.vue?vue&type=style&index=1&id=3d8ec4f6&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports